"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSuccessPercent = exports.validProgress = void 0;
function validProgress(progress) {
    if (!progress || progress < 0) {
        return 0;
    }
    if (progress > 100) {
        return 100;
    }
    return progress;
}
exports.validProgress = validProgress;
function getSuccessPercent(_a) {
    var success = _a.success, successPercent = _a.successPercent;
    var percent = successPercent;
    /** @deprecated Use `percent` instead */
    if (success && 'progress' in success) {
        percent = success.progress;
    }
    if (success && 'percent' in success) {
        percent = success.percent;
    }
    return percent;
}
exports.getSuccessPercent = getSuccessPercent;
//# sourceMappingURL=utils.js.map